export function assetKey(address) {
  const text = String(address || '');
  if (/^-?\d+:[0-9a-f]{64}$/i.test(text)) return text.toLowerCase();
  try {
    const bytes = atob(text.replace(/-/g, '+').replace(/_/g, '/'));
    if (bytes.length !== 36) return text;
    const wc = bytes.charCodeAt(1);
    const hex = Array.from(bytes.slice(2, 34), c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
    return `${wc > 127 ? wc - 256 : wc}:${hex}`;
  } catch { return text; }
}
